import * as React from "react";
import { Job } from "@models/job";
import { Button, Divider, Modal, Table, Avatar } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import Message from "@constants/message";
import JobForm from "@components/jobs/Form";
import { NavLink } from "react-router-dom";
import { PaginationDefaultParams } from "../custom/Paginator";

type Props = {
  data: Job[];
  loading: boolean;
  deleteFn: (item: Job) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const JobsTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteJob = (item: Job): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`} />,
      width: 150,
      dataIndex: "title",
      key: "title"
    },
    {
      title: "",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/jobs/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteJob(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(JobsTable);
